// 登录
const login = {
  "欢迎您的登录": "Welcome to login",
  "普通登录": "Normal Login",
  "短信登录": "SMS Login",
  "商户绑定手机号": "Merchant bound phone number",
  "请输入手机号": "Please enter your phone number",
  "登陆员工工号": "Employee ID",
  "请选择登录门店": "Please select the login store",
  "登录员工密码": "Employee Password",
  "请输入用户名": "Please enter the username",
  "请输入密码": "Please enter the password",
  "请输入商户绑定手机号": "Please enter the merchant bound phone number",
  "请输入验证码": "Please enter the verification code",
  "发送验证码": "Send Verification Code",
  "登录": "Login",
  "还没有账号": "Don't have an account",
  "立即注册": "Register Now"
}

// 首页
const index = {
  '商店': 'Shop',
  '报表': 'Reports',
  '营业概况': 'Business Overview',
  '会员': 'Members',
  '会员信息': 'Member',
  '基础': 'Basic',
  '设置': 'Set',
  '菜品信息': 'Dish',
  '套餐信息': 'Set Menu',
  '餐桌信息': 'Table',
  '门店信息': 'Store',
  '员工信息': 'Employee',
  '常用备注': 'Common Remarks',
  '收款方式': 'Collection Account',
  '设备': 'Devices',
  '设备管理': 'Device Management',
  '门店': 'Store',
  '注销登录': 'Logout',
  '修改密码': 'Modify Password',
  '旧密码': 'Old Password',
  '新密码': 'New Password',
  '确认密码': 'Confirm Password',
  '取消': 'Cancel',
  '确定': 'Confirm',
  "导航": " Navigation",
  "线上商店": "Online Store",
  "商店/线上商店": "Shop/Online Store",
  "报表/营业概况": "Reports/Business Overview",
  "会员/会员信息": "Members/Member Information",
  "基础/菜品信息": "Basic/Dish Information",
  "基础/套餐信息": "Basic/Set Menu Information",
  "基础/餐桌信息": "Basic/Table Information",
  "基础/门店信息": "Basic/Store Information",
  "基础/员工信息": "Basic/Employee Information",
  "基础/常用备注": "Basic/Common Remarks",
  "基础/收款方式": "Basic/Collection Account",
  "设置/设备管理": "Set/Device Management",
}

// 菜品
const dish = {
  "菜品档案": "Dish Archive",
  "新增": "Add",
  "管理": "Manage",
  "修改本级": "Edit This Level",
  "新增同级": "Add Sibling",
  "新增下级": "Add Subordinate",
  "查询": "Search",
  "模糊": "Fuzzy",
  "非正常": "Abnormal",
  "全部": "All",
  "在售": "On Sale",
  "停售": "Off Sale",
  "删除": "Deleted",
  "编辑": "Edit",
  "状态": "Status",
  "菜品编码": "Dish Code",
  "规格编码": "Specification Code",
  "菜品名称": "Dish Name",
  "基本单位": "Basic Unit",
  "销售价": "Sales Price",
  "会员价": "Member Price",
  "所属分类": "Belonging Category",
  "计重": "Weight",
  "时价": "Timely Price",
  "热销": "Hot Sale",
  "推荐": "Recommend",
  "库存": "Stock",
  "创建员工": "Creator",
  "创建时间": "Creation Time",
  "修改员工": "Modifier",
  "修改时间": "Modification Time",
  "修改来源": "Modification Source",
  "管理菜品分类": "Manage Dish Categories",
  "导出菜品": "Export Dish",
  "操作": "Action",
  "共": "Total",
  "页": "Pages",
  "条": "Items",
  "序号": "Seq",
  "上级分类": "Parent Category",
  "分类名称": "Category Name",
  "显示排序": "Display Order",
  "当前状态": "Current Status",
  "正常": "Normal",
  "是否售卖": "For Sale",
  "保存": "Save",
  "图片展示示例": "Image Display Example",
  "图片": "Image",
  "确认": "Confirm",
  "取消": "Cancel",
  "零售价格": "Retail Price",
  "起售数量": "Minimum Order Quantity",
  "每单限购": "Maximum Order Quantity",
  "管理库存": "Inventory Management",
  "一品多码": "One Dish Multiple Codes",
  "库存数量": "Stock Quantity",
  "菜品描述": "Dish Description",
  "允许销售": "Allow Sale",
  "允许优惠": "Allow Discount",
  "仅套餐售卖": "Only Sold in Packages",
  "选择规格": "Select Specification",
  "选择加料": "Select Add-ons",
  "选择做法": "Select Flavors",
  "进货价格": "Purchase Price",
  "最低售价": "Minimum Sale Price",
  "销售积分": "Sales Points",
  "收银员提成": "Cashier Commission",
  "提成比例": "Commission Rate",
  "生产日期": "Production Date",
  "服务员提成": "Waiter Commission",
  "保质期限": "Expiry Period",
  "推销员提成": "Salesperson Commission",
  "提成金额": "Commission Amount",
  "菜品税率": "Dish Tax Rate",
  "拼音简码": "Pinyin Abbreviation",
  "定时销售": "Timed Sales",
  "星期": "Weekdays",
  "时段": "Time Period",
  "开始时间": "Start Time",
  "结束时间": "End Time",
  "选择时间范围": "Select Time Range",
  "选择厨打": "Select Kitchen Printing",
  "选择原料": "Select Raw Materials",
  "生成": "Generate",
  "本地上传": "Local Upload",
  "云库选择": "Cloud Library Selection",
  "新增同级分类": "Add Sibling Category",
  "新增下级分类": "Add Subordinate Category",
  "修改菜品分类": "Modify Dish Category",
  "新增菜品": "New Dish",
  "菜品分类": "Dish Category",
  "加载中...": "Loading...",
  "放大": "Zoom In",
  "销售时自动弹出加料选择": "Automatically Pop Up Additive Selection During Sales",
  "销售时自动弹出做法选择": "Automatically Pop Up Flavor Selection During Sales",
  "提示": "Prompt",
  "商品未保存，是否立即保存": "The product has not been saved, do you want to save it immediately?",
  "确定": "Confirm",
  "否": "No",
  "是": "Yes",
  "确定要删除数据吗?": "Are you sure you want to delete the data?",
  "已取消删除": "Deletion canceled",
  "请先选择菜品分类": "Please select the dish category first",
  "请先输入菜品名称": "Please enter the dish name first",
  "请先生成菜品编码": "Please generate the dish code first",
  "请先输入基本单位": "Please enter the basic unit first",
  "请先输入显示排序": "Please enter the display order first",
  "请先输入零售价格": "Please enter the retail price first",
  "请先输入会员价格": "Please enter the member price first",
  "请先选择当前状态": "Please select the current status first",
  "保存产品信息时出错": "Error saving product information",
  "按菜品": "By Dish",
  "按原料": "By Ingredient",
  "不管理": "Not Managed",
  "规格编码": "Specification Code",
  "规格名称": "Specification Name",
  "计价单位": "Pricing Unit",
  "配比倍数": "Ratio Multiple",
  "编码": "Code",
  "名称": "Name",
  "加价": "Price Increase",
  "自动新增": "Auto Add",
  "请输入显示排序": "Please enter the display order",
  "请输入菜品名称": "Please enter the dish name",
  "请输入菜品编码": "Please enter the dish code",
  "请输入基本单位": "Please enter the basic unit",
  "请输入零售价格": "Please enter the retail price",
  "请输入会员价格": "Please enter the member price",
  "请输入当前状态": "Please enter the current status",
  "请输入起售数量": "Please enter the minimum order quantity",
  "请输入每单限购": "Please enter the maximum order quantity",
  "请输入进货价格": "Please enter the purchase price",
  "请输入最低售价": "Please enter the minimum sale price",
  "请输入管理库存": "Please enter the inventory management",
  "请输入一品多码": "Please enter the one dish multiple codes",
  "请输入库存数量": "Please enter the stock quantity",
  "请输入菜品描述": "Please enter the dish description",
  "请输入销售积分": "Please enter the sales points",
  "请选择收银员提成": "Please enter the cashier's commission",
  "请输入提成比例": "Please enter the commission rate",
  "请输入生产日期": "Please enter the production date",
  "请选择服务员提成": "Please enter the waiter's commission",
  "请输入保质期限": "Please enter the expiry period",
  "请选择推销员提成": "Please enter the salesperson's commission",
  "请输入提成金额": "Please enter the commission amount",
  "请输入菜品税率": "Please enter the dish tax rate",
  "请输入拼音简码": "Please enter the pinyin abbreviation",
  "请选择定时销售": "Please select timed sales",
  "请选择星期": "Please select weekdays",
  "请选择时段": "Please select time period",
  "请选择开始时间": "Please select start time",
  "请选择结束时间": "Please select end time",
  "请输入有效的数字值": "Please enter a valid numeric value",
  "一": "Monday",
  "二": "Tuesday",
  "三": "Wednesday",
  "四": "Thursday",
  "五": "Friday",
  "六": "Saturday",
  "日": "Sunday",
  "编码": "Code",
  "名称": "Name",
  "加价": "Price Increase",
  "厨打": "kitchen printing",
  "原料": "raw materials",
  "生成": "generate",
  "本地上传": "local upload",
  "云库选择": "cloud library selection",
  "销售时自动弹出加料选择": "Automatic popup of additives during sales",
  "销售时自动弹出做法选择": "Automatic popup of flavors during sales",
  "规格编码": "Specification Code",
  "规格名称": "Specification Name",
  "计价单位": "Pricing Unit",
  "配比倍数": "Ratio Multiple",
  "编码": "Code",
  "名称": "Name",
  "加价": "Price Increase",
  "请输入菜品条码和菜品名称": "Please enter the dish barcode and dish name",
  "商品未保存，是否立即保存": "The product has not been saved, do you want to save it immediately?",
  "确定要删除数据吗?": "Are you sure you want to delete the data?",
  "提示": "Prompt",
  "已取消删除": "Deletion canceled",
  "保存产品信息时出错": "Error saving product information",
  "请输入规格名称": "Please enter the specification name",
  "请输入规格编码": "Please enter the specification code",
  "新增规格": "New Specification",
  "规格信息": "Specification Information",
  "请输入计价单位": "Please enter the pricing unit",
  "请输入配比倍数": "Please enter the ratio multiple",
  "请输入编码": "Please enter the code",
  "请输入名称": "Please enter the name",
  "规格图片展示示例": "Specification Image Display Example",
  "规格图片": "Specification Image",
  "保存规格信息时出错": "Error saving specification information",
  "会员价格": "Member Price",
  "菜品图片展示示例": "Dish Image Display Example",
  "菜品图片": "Dish Image",
  "称重": "Weight",
  "基本信息": "Basic Information",
  "销售提成": "Sales Commission",
  "多规格": "Multi-Specification",
  "加料": "Add-ons",
  "做法": "Flavors",
  "更多": "More",
  "厨打": "Kitchen Printing",
  "原料": "Raw Materials",
  "规格描述": "Specification Description",
  "请输入规格描述": "Please enter the specification description",
  "按比例": "By Ratio",
  "按数量": "By Quantity",
  "按金额": "By Amount",
  "按毛利": "By Profit",
  "请输入分类名称": "Please enter the category name",
  "确认选择": "Confirm Selection",
  "新增加料": "New Add-ons",
  "删除产品信息时出错": "Error deleting product information",
  "确定要删除该加料吗?": "Are you sure you want to delete the add-ons?",
  "所属分类不能为空": "The belonging category cannot be empty",
  "加料名称不能为空": "Add-ons name cannot be empty",
  "加料编码不能为空": "Add-ons code cannot be empty",
  "加料价格不能为空": "Add-ons price cannot be empty",
  "加料名称": "Add-ons Name",
  "加料编码": "Add-ons Code",
  "加料加价": "Add-ons Price Increase",
  "请输入加料名称": "Please enter the add-ons name",
  "请输入加料编码": "Please enter the add-ons code",
  "请输入加料加价": "Please enter the add-ons price increase",
  "保存加料信息时出错": "Error saving add-ons information",
  "删除加料信息时出错": "Error deleting add-ons information",
  "确定要删除该做法吗?": "Are you sure you want to delete the flavor?",
  "做法名称不能为空": "Flavor name cannot be empty",
  "做法编码不能为空": "Flavor code cannot be empty",
  "做法加价不能为空": "Flavor price increase cannot be empty",
  "做法名称": "Flavor Name",
  "做法编码": "Flavor Code",
  "做法加价": "Flavor Price Increase",
  "请输入做法名称": "Please enter the flavor name",
  "请输入做法编码": "Please enter the flavor code",
  "请输入做法加价": "Please enter the flavor price increase",
  "保存做法信息时出错": "Error saving flavor information",
  "删除做法信息时出错": "Error deleting flavor information",
  "请输入套餐名称": "Please enter the set menu name",
  "请输入套餐编码": "Please enter the set menu code",
  "请勾选数据": "Please check the data",
  "请求失败，请稍后再试": "Request failed, please try again later",
  "确定要删除该做法分类吗?": "Are you sure you want to delete the flavor category?",
  "做法分类名称不能为空": "Flavor category name cannot be empty",
  "做法分类编码不能为空": "Flavor category code cannot be empty",
  "请选择": "Please select",
}

// 桌台
const table = {
  "门店档案": "Store Archive",
  "新增": "Add",
  "管理": "Manage",
  "修改本级": "Edit Current Level",
  "新增同级": "Add Sibling",
  "新增下级": "Add Subordinate",
  "编码，名称，手机号": "Code, Name, Phone Number",
  "查询": "Search",
  "模糊": "Fuzzy",
  "非正常": "Abnormal",
  "批量新增": "Batch Add",
  "新增餐桌": "Add Table",
  "编辑": "Edit",
  "共": "Total",
  "页": "Pages",
  "条": "Records",
  "状态": "Status",
  "餐桌编码": "Table Code",
  "桌台名称": "Table Name",
  "所属区域": "Belonging Area",
  "可坐人数": "Seating Capacity",
  "创建员工": "Created By",
  "创建时间": "Creation Time",
  "修改员工": "Modified By",
  "修改时间": "Modification Time",
  "新增同级分类": "Add Sibling Category",
  "新增下级分类": "Add Subordinate Category",
  "修改区域列表": "Edit Area List",
  "管理门店分类": "Manage Store Categories",
  "修改门店": "Modify Store",
  "新增门店": "Add Store",
  "开发中": "Under Development",
  "没有": "No",
  "的权限": "Permission",
  "上级分类": "Parent Category",
  "区域名称": "Area Name",
  "显示排序": "Display Order",
  "当前状态": "Current Status",
  "删除": "Delete",
  "保存": "Save",
  "正常": "Normal",
  "删除": "Deleted",
  "是否确认删除": "Are you sure you want to delete?",
  "确定": "Confirm",
  "取消": "Cancel",
  "请输入区域名称": "Please enter the area name",
  "请输入显示排序": "Please enter the display order",
  "操作失败": "Operation failed",
  "修改区域列表": "Edit Area List",
  "新增同级分类": "Add Sibling Category",
  "新增下级分类": "Add Subordinate Category",
  "餐桌名称": "Table Name",
  "最低消费": "Minimum Consumption",
  "桌台码": "Table Code",
  "请输入餐桌名称": "Please enter the table name",
  "请输入餐桌编码": "Please enter the table code",
  "请输入最低消费": "Please enter the minimum consumption",
  "请选择所属区域": "Please select the belonging area",
  "请输入可坐人数": "Please enter the seating capacity",
  "选择当前状态": "Select Current Status",
  "已取消删除": "Deletion canceled",
  "新增餐桌": "Add Table",
  "修改餐桌": "Modify Table",
}


// 门店
const mall = {
  "门店档案": "Store Archive",
  "新增": "Add",
  "管理": "Manage",
  "修改本级": "Edit Current Level",
  "新增同级": "Add Sibling",
  "新增下级": "Add Subordinate",
  "编码，名称，手机号": "Code, Name, Phone Number",
  "查询": "Search",
  "模糊": "Fuzzy",
  "非正常": "Abnormal",
  "新增门店": "Add Store",
  "编辑": "Edit",
  "共": "Total",
  "页": "Pages",
  "条": "Records",
  "状态": "Status",
  "门店编码": "Store Code",
  "门店名称": "Store Name",
  "经营类型": "Business Type",
  "所属区域": "Belonging Area",
  "地址": "Address",
  "面积": "Area",
  "门店电话": "Store Phone",
  "负责人": "Contact Person",
  "员工数": "Number of Employees",
  "商品数": "Number of Products",
  "创建员工": "Created By",
  "创建时间": "Creation Time",
  "修改员工": "Modified By",
  "修改时间": "Modification Time",
  "来源": "Source",
  "管理门店分类": "Manage Store Categories",
  "修改门店": "Modify Store",
  "没有": "No",
  "的权限": "Permission",
  "导出门店": "Export Stores",
  "上级分类": "Parent Category",
  "区域名称": "Area Name",
  "显示排序": "Display Order",
  "当前状态": "Current Status",
  "删除": "Delete",
  "保存": "Save",
  "正常": "Normal",
  "删除": "Deleted",
  "是否确认删除": "Are you sure you want to delete?",
  "确定": "Confirm",
  "取消": "Cancel",
  "请输入区域名称": "Please enter the area name",
  "请输入显示排序": "Please enter the display order",
  "操作失败": "Operation failed",
  "修改门店分类": "Edit Store Category",
  "新增同级分类": "Add Sibling Category",
  "新增下级分类": "Add Subordinate Category",
  "门店信息": "Store Information",
  "基本信息": "Basic Information",
  "线上属性": "Online Attributes",
  "所属分类": "Belonging Category",
  "门店名称": "Store Name",
  "请输入门店名称": "Please enter the store name",
  "门店编码": "Store Code",
  "请输入门店编码": "Please enter the store code",
  "经营方式": "Business Type",
  "请输入经营方式": "Please enter the business type",
  "负责人": "Contact Person",
  "请输入负责人": "Please enter the contact person",
  "联系电话": "Contact Phone",
  "请输入联系电话": "Please enter the contact phone",
  "门店照片": "Store Photo",
  "加载中...": "Loading...",
  "门店面积": "Store Area",
  "请输入门店面积": "Please enter the store area",
  "门店电话": "Store Phone",
  "请输入门店电话": "Please enter the store phone",
  "显示排序": "Display Order",
  "请输入显示排序": "Please enter the display order",
  "门店地址": "Store Address",
  "请输入门店地址": "Please enter the store address",
  "当前状态": "Current Status",
  "请输入当前状态": "Please enter the current status",
  "备注信息": "Remark Information",
  "请输入备注信息": "Please enter the remark information",
  "定位区域": "Location Area",
  "请输入定位区域": "Please enter the location area",
  "定位地址": "Location Address",
  "请输入定位地址": "Please enter the location address",
  "定位经度": "Longitude",
  "请输入定位经度": "Please enter the longitude",
  "定位纬度": "Latitude",
  "请输入定位纬度": "Please enter the latitude",
  "投诉电话": "Complaint Phone",
  "请输入投诉电话": "Please enter the complaint phone",
  "配送范围": "Delivery Range",
  "请输入配送范围": "Please enter the delivery range",
  "配送费用": "Delivery Fee",
  "请输入配送费用": "Please enter the delivery fee",
  "起送金额": "Minimum Order Amount",
  "请输入起送金额": "Please enter the minimum order amount",
  "营业开始": "Business Start Time",
  "请输入营业开始时间": "Please enter the business start time",
  "营业结束": "Business End Time",
  "请输入营业结束时间": "Please enter the business end time",
  "订单满额": "Order Full Amount",
  "请输入订单满额": "Please enter the order full amount",
  "配送说明": "Delivery Description",
  "请输入配送说明": "Please enter the delivery description",
  "店铺说明": "Store Description",
  "请输入店铺说明": "Please enter the store description",
  "线上显示": "Online Display",
  "线上销售": "Online Sales",
  "删除": "Delete",
  "保存": "Save",
  "图片": "Image",
  "确定要删除该门店吗?": "Are you sure you want to delete this store?",
  "提示": "Prompt",
  "确定": "Confirm",
  "取消": "Cancel",
  "已取消删除": "Deletion canceled",
  "生成": "Generate",
  "自营": "Self-operated",
  "联营": "Joint Venture",
  "正常": "Normal",
  "删除": "Deleted",
  "请先选择所属分类": "Please select the belonging category first",
  "请先输入门店名称": "Please enter the store name first",
  "请先输入门店编码": "Please enter the store code first",
  "请先选择经营方式": "Please select the business type first",
  "请先输入显示排序": "Please enter the display order first",
  "请先选择当前状态": "Please select the current status first",
  "请选择": "Please select",
  "操作": "Action",


}

//套餐
const combo = {
  "套餐名称": "Package Name",
  "套餐编码": "SKU Code",
  "销售价格": "Sale Price",
  "销售价": "Sale Price",
  "当前状态": "Status",
  "会员价格": "VIP Price",
  "会员价": "VIP Price",
  "销售积分": "Reward Points",
  "套餐图片": "Package Image",
  "加载中...": "Loading...",
  "删除": "Delete",
  "请选择服务员提成方式": "Commission Type",
  "提成比例": "Commission Rate",
  "拼音简码": "Pinyin Abbr",
  "服务员提成": "Server Commission",
  "提成金额": "Commission Amount",
  "起售份数": "Min.Quantity",
  "推销员提成": "Promoter Commission",
  "最多可选": "Max.Selection",
  "保存": "Save",
  "新增套餐": "Create Package	",
  '编码，名称': 'Code, Name',
  "模糊": "Fuzzy",
  "非正常": "Abnormal",
  "查询": "Search",
  "套餐图片展示示例": "Package Image Display Example",
  "套餐图片": "Package Image",
  "保存套餐信息时出错": "Error saving package information",
  "请输入套餐名称": "Please enter the package name",
  "请输入套餐编码": "Please enter the package code",
  "请输入销售价格": "Please enter the sale price",
  "请输入会员价格": "Please enter the VIP price",
  "请输入销售积分": "Please enter the reward points",
  "请选择当前状态": "Please select the current status",
  "请选择服务员提成方式": "Please select the server commission type",
  "请输入提成比例": "Please enter the commission rate",
  "请输入拼音简码": "Please enter the pinyin abbreviation",
  "请输入服务员提成": "Please enter the server commission",
  "请输入提成金额": "Please enter the commission amount",
  "请输入起售份数": "Please enter the minimum quantity",
  "请选择推销员提成方式": "Please select the promoter commission type",
  "请输入推销员提成": "Please enter the promoter commission",
  "请输入提成金额": "Please enter the commission amount",
  "请输入最多可选": "Please enter the maximum selection",
  "请选择": "Please select",
  "操作": "Action",
  "确定要删除该套餐吗?": "Are you sure you want to delete this package?",
  "提示": "Prompt",
  "确定": "Confirm",
  "取消": "Cancel",
  "已取消删除": "Deletion canceled",
  "请先选择所属分类": "Please select the belonging category first",
  "请先输入套餐名称": "Please enter the package name first",
  "请先输入套餐编码": "Please enter the package code first",
  "请先输入销售价格": "Please enter the sale price first",
  "请先输入会员价格": "Please enter the VIP price first",
  "请先输入销售积分": "Please enter the reward points first",
  "请先选择当前状态": "Please select the current status first",
  "请选择服务员提成方式": "Please select the server commission type first",
  "请先输入提成比例": "Please enter the commission rate first",
  "请先输入拼音简码": "Please enter the pinyin abbreviation first",
  "请先输入服务员提成": "Please enter the server commission first",
  "请先输入提成金额": "Please enter the commission amount first",
  "请先输入起售份数": "Please enter the minimum quantity first",
  "请选择推销员提成方式": "Please select the promoter commission type first",
  "请先输入推销员提成": "Please enter the promoter commission first",
  "请先输入提成金额": "Please enter the commission amount first",
  "请先输入最多可选": "Please enter the maximum selection first",
  "请选择": "Please select",
  "操作": "Action",
  "确定要删除该套餐吗?": "Are you sure you want to delete this package?",
  "提示": "Prompt",
  "确定": "Confirm",
  "取消": "Cancel",
  "已取消删除": "Deletion canceled",
  "全部": "All",
  "在售": "On Sale",
  "停售": "Off Sale",
  "删除": "Delete",
  "保存": "Save",
  "按比例": "By Ratio",
  "按数量": "By Quantity",
  "按金额": "By Amount",
  "按毛利": "By Profit",
  '基本信息': 'Basic Information',
  '必选菜品': 'Mandatory Dishes',
  '可选菜品1': 'Optional Dishes1',
  '可选菜品2': 'Optional Dishes2',
  '可选菜品3': 'Optional Dishes3',
  "显示名称": "Display Name",
  "选择菜品": "Select Dishes",
  '菜品名称': 'Dish Name',
  '菜品编码': 'Dish Code',
  '单位': 'Unit',
  '数量': 'Quantity',
  '零售价': 'Retail Price',
  '请输入显示名称': 'Please enter the display name',
  '创建员工': 'Created By',
  '创建时间': 'Creation Time',
  '修改套餐': 'Modify Package',
  '修改时间': 'Modification Time',
  "生成": "Generate",
  '放大': 'Zoom In',
  "编辑": "Edit",
  "套餐描述": "Package Description",
  "请输入套餐描述": "Please enter the package description",
  "收银员提成": "Cashier's Commission",
  "限购份数": "Max.Quantity",
  "请输入限购份数": "Please enter the maximum quantity",
  "确认删除?": "Confirm Delete?",
  "提示": "Prompt",
  "确定": "Confirm",
  "取消": "Cancel",
  "已取消删除": "Deletion canceled",
}
// 用户
const user = {
  "新增": "Add",
  "管理": "Manage",
  "修改本级": "Edit Current Level",
  "新增同级": "Add Sibling",
  "新增下级": "Add Subordinate",
  "编码，名称，手机号": "Code, Name, Phone Number",
  "查询": "Search",
  "模糊": "Fuzzy",
  "非正常": "Abnormal",
  "批量新增": "Batch Add",
  "新增餐桌": "Add Table",
  "编辑": "Edit",
  "共": "Total",
  "页": "Pages",
  "条": "Records",
  "状态": "Status",
  "新增员工": "Add Employee",
  "序号": "Seq",
  "操作": "Action",
  "员工编码": "Employee Code",
  '员工姓名': 'Employee Name',
  '所属门店': 'Belonging Store',
  '最大优惠': 'Maximum Discount',
  '最大折扣': 'Maximum Discount',
  '创建员工': 'Created By',
  '创建时间': 'Creation Time',
  '修改员工': 'Modified By',
  '修改时间': 'Modification Time',
  "权限管理": "Permission Management",
  "收银权限": "Cashier Permission",
  "新增员工": "Add Employee",
  "修改员工": "Modify Employee",
  "基本信息": "Basic Information",
  "更多信息": "More Information",
  "所属分组": "Belonging Group",
  "所属门店": "Belonging Store",
  "员工工号": "Employee Code",
  "登录密码": "Login Password",
  "员工姓名": "Employee Name",
  "健康证": "Health Certificate",
  "加载中...": "Loading...",
  "放大": "Zoom In",
  "删除": "Delete",
  "最大折扣": "Maximum Discount",
  "单品最大折扣": "Single Product Maximum Discount",
  "当前职务": "Current Position",
  "最大优惠": "Maximum Discount",
  "单品最大优惠": "Single Product Maximum Discount",
  "显示排序": "Display Order",
  "提成方式": "Commission Type",
  "提成值": "Commission Value",
  "当前状态": "Current Status",
  "备注信息": "Remark Information",
  "员工性别": "Employee Gender",
  "员工生日": "Employee Birthday",
  "最高学历": "Highest Education",
  "现住地址": "Residential Address",
  "户籍地址": "Registration Address",
  "选择日期": "Select Date",
  "请选择提成方式": "Please select the commission type",
  "请选择当前状态": "Please select the current status",
  "请选择员工性别": "Please select the employee gender",
  "请输入员工编码": "Please enter the employee code",
  "请输入登录密码": "Please enter the login password",
  "请输入员工姓名": "Please enter the employee name",
  "请输入最高学历": "Please enter the highest education",
  "请输入现住地址": "Please enter the residential address",
  "请输入户籍地址": "Please enter the registration address",
  "请输入备注信息": "Please enter the remark information",
  "请输入零售价格": "Please enter the retail price",
  "生成": "Generate",
  "删除": "Delete",
  "保存": "Save",
  "确定要删除该员工吗?": "Are you sure you want to delete this employee?",
  "提示": "Prompt",
  "确定": "Confirm",
  "取消": "Cancel",
  "已取消删除": "Deletion canceled",
  "保存员工信息时出错": "Error saving employee information",
  "删除员工信息时出错": "Error deleting employee information",
  "请输入当前职务": "Please enter the current position",
  "请输入最大优惠": "Please enter the maximum discount",
  "请输入单品最大优惠": "Please enter the single product maximum discount",
  "请输入显示排序": "Please enter the display order",
  "请输入提成值": "Please enter the commission value",
  "请选择": "Please select",
  "正常": "Normal",
  "删除": "Delete",
  "按商品": "By Product",
  "按整单": "By Order",
  "男": "Male",
  "女": "Female",
}

//备注
const remark = {
  "编码，名称": "Code, Name",
  "查询": "Search",
  "模糊": "Fuzzy",
  "非正常": "Abnormal",
  "新增备注": "Add Remark",
  "编辑": "Edit",
  "共": "Total",
  "页": "Pages",
  "条": "Records",
  "状态": "Status",
  "备注名称": "Remark Name",
  "备注编码": "Remark Code",
  "创建员工": "Created By",
  "创建时间": "Creation Time",
  "修改员工": "Modified By",
  "修改时间": "Modification Time",
  "备注信息": "Remark Information",
  "确定要删除该备注吗?": "Are you sure you want to delete this remark?",
  "提示": "Prompt",
  "确定": "Confirm",
  "取消": "Cancel",
  "已取消删除": "Deletion canceled",
  "请输入备注内容": "Please enter the remark content",
  "请输入显示排序": "Please enter the display order",
  "请选择当前状态": "Please select the current status",
  "备注类型": "Remark Type",
  "备注内容": "Remark Content",
  "显示排序": "Display Order",
  "删除": "Delete",
  "保存": "Save",
  "来源": "Source",
  "操作": "Action",
  "单品备注": "Single Product Remark",
  "整单备注": "Whole Order Remark",
  "退款备注": "Refund Remark",
  '退菜备注': 'Dish Return Remark',
  "打折/赠送原因": "Discount/Gift Reason",
  "充值备注": "Recharge Remark",
  "开台备注": "Open Table Remark",
  "常用备注": "Common Remark",

}

//账户
const acct = {
  "编码，名称，手机号": "Code, Name, Phone Number",
  "查询": "Search",
  "模糊": "Fuzzy",
  "非正常": "Abnormal",
  "新增账户": "Add Account",
  "编辑": "Edit",
  "状态": "Status",
  "账户名称": "Account Name",
  "账户描述": "Account Description",
  "虚收账户": "Virtual Collection Account",
  "后台交易": "Background Transaction",
  "收银交易": "Cashier Transaction",
  "创建员工": "Created By",
  "创建时间": "Creation Time",
  "修改员工": "Modified By",
  "修改时间": "Modification Time",
  "来源": "Source",
  "共": "Total",
  "页": "Pages",
  "条": "Records",
  "序号": "Order",
  "操作": "Action",
  "没有": "No",
  "的权限": "Permission",
  "导出账户": "Export Accounts",
  "账户信息": "Account Information",
  "账户名称": "Account Name",
  "显示排序": "Display Order",
  "当前状态": "Current Status",
  "快捷键值": "Shortcut Value",
  "账户描述": "Account Description",
  "虚收账户": "Virtual Collection Account",
  "后台交易": "Background Transaction",
  "收银交易": "Cashier Transaction",
  "删除": "Delete",
  "保存": "Save",
  "确定要删除该账户吗?": "Are you sure you want to delete this account?",
  "提示": "Prompt",
  "确定": "Confirm",
  "取消": "Cancel",
  "已取消删除": "Deletion canceled",
  "请先输入账户名称": "Please enter the account name",
  "请先输入显示排序": "Please enter the display order",
  "请先选择当前状态": "Please select the current status",
  "正常": "Normal",
  "删除": "Deleted",
  "请输入账户名称": "Please enter the account name",
  "请输入显示排序": "Please enter the display order",
  "请输入当前状态": "Please enter the current status",
  "请输入快捷键值": "Please enter the shortcut value",
  "请输入账户描述": "Please enter the account description",
}
// 总模块
const enUsLng = {
  index,
  dish,
  table,
  login,
  mall,
  combo,
  user,
  remark,
  acct,
}

export default enUsLng



// WEBPACK FOOTER //
// ./src/assets/lng/en-US.js